import React, { useEffect } from 'react'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function PrivacyPolicy() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="1138" className="elementor elementor-1138">
										<div className="elementor-element elementor-element-eab02f4 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="eab02f4" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-ca91da9 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ca91da9" data-element_type="container" data-e-type="container">
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-ac466bb elementor-widget elementor-widget-elementskit-heading" data-id="ac466bb" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Privacy Policy</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div><span className="ekit-heading--subtitle elementskit-section-subtitle  ">
																Last Updated: 20:12 October 16, 2025
															</span></div></div>				</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-3b81da0 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="3b81da0" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-3293424 elementor-widget__width-initial elementor-widget elementor-widget-elementskit-heading" data-id="3293424" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">				<div className="ekit-heading__description">
															<p>At TSR Catering &amp; Events (operated under AlphaFoods), your privacy is important to us. This Privacy Policy outlines how we collect, use, store, and protect your personal information across our brands, including TSR Catering &amp; Events and Party Meals by Kilo.</p>
														</div>
														</div></div>				</div>
												</div>
												<div className="elementor-element elementor-element-0925eff elementor-widget elementor-widget-heading" data-id="0925eff" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h4 className="elementor-heading-title elementor-size-default">1. Information We Collect</h4>				</div>
												</div>
												<div className="elementor-element elementor-element-682c7b6 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="682c7b6" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-text">We may collect your name, contact details, event preferences, and feedback when you inquire, book, or interact with us.</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-5052cdb e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="5052cdb" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-f00ff2d elementor-widget elementor-widget-heading" data-id="f00ff2d" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h4 className="elementor-heading-title elementor-size-default">

															2. How We Collect Data</h4>				</div>
												</div>
												<div className="elementor-element elementor-element-2ceaa82 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="2ceaa82" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-text">Your data helps us plan, deliver, and improve our catering and event services, send order updates, offers, and ensure a smooth experience.</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-70c0d9a e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="70c0d9a" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-c077154 elementor-widget elementor-widget-heading" data-id="c077154" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h4 className="elementor-heading-title elementor-size-default">

															3. Data Protection</h4>				</div>
												</div>
												<div className="elementor-element elementor-element-d3efd4c elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="d3efd4c" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-text">We do not sell, trade, or share your personal information with unauthorized parties. All data is stored securely and used only for service-related purposes.</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-f1361cb e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="f1361cb" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-d369400 elementor-widget elementor-widget-heading" data-id="d369400" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h4 className="elementor-heading-title elementor-size-default">

															4. Cookies and Analytics</h4>				</div>
												</div>
												<div className="elementor-element elementor-element-f48463a elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="f48463a" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-text">Our website may use cookies for a better browsing experience. You may opt out anytime.</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-778ec55 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="778ec55" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-651bf6a elementor-widget elementor-widget-heading" data-id="651bf6a" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h4 className="elementor-heading-title elementor-size-default">

															5. Policy Updates:</h4>				</div>
												</div>
												<div className="elementor-element elementor-element-9b89d11 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="9b89d11" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-text">TSR Catering &amp; Events reserves the right to update this policy periodically. The latest version will always be available on our website.</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-ddc2027 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="ddc2027" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-5efaea4 elementor-widget elementor-widget-heading" data-id="5efaea4" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h4 className="elementor-heading-title elementor-size-default">

															11. Contact Us</h4>				</div>
												</div>
												<div className="elementor-element elementor-element-fde56ef elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="fde56ef" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-text">For questions, feedback, or data-related requests, contact:</span>
															</li>
														</ul>
													</div>
												</div>
												<div className="elementor-element elementor-element-9a60873 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="9a60873" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<i aria-hidden="true" className="icon icon-email"></i>						</span>
																<span className="elementor-icon-list-text">alpphafoods@gmail.com</span>
															</li>
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<i aria-hidden="true" className="icon icon-phone1"></i>						</span>
																<span className="elementor-icon-list-text">7249464781</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-d258937 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="d258937" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-cb5cb29 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="cb5cb29" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-9d28830 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="9d28830" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
																												<EnquiryHeading widgetElementId="9eb4cd9" />

																												<EnquiryForm widgetElementId="ce50739" />

													</div>
												</div>
											</div>
										</div>
									</div>



								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default PrivacyPolicy

